import game, { config } from '../game';
import TextBlurbScene from './TextBlurbScene';

export default class Splash extends Phaser.Scene {
    CRTPipeline: any;

    constructor() {
      super({ key: 'Splash' });
    }

    preload(){
      const renderer = < Phaser.Renderer.WebGL.WebGLRenderer>game.renderer;
      this.CRTPipeline = renderer.getPipeline('CRT');
    }
  
    create() {
      this.sys.canvas.style.cursor = "none";
      this.cameras.main.setRenderToTexture(this.CRTPipeline);
        var Ident = this.add.image( <number>config.width/2,<number>config.height/2,'IdentLogo');
        Ident.setOrigin(.5,.5);
        this.tweens.add({
          targets: Ident,
          alpha: { from: 0, to: 1 },
          duration: 500
        });
        this.tweens.add({
          targets: this.CRTPipeline,
          intensity: { from: 0.1, to: 3 },
          duration: 1000,
          hold: 500,
          completeDelay: 1000,
          yoyo: true,
          onComplete: () => {
            this.sys.canvas.style.cursor = "auto";
            this.scene.switch("TextBlurbScene");
          }
        });
    }

    update(time,delta){
      this.CRTPipeline.time+=delta;
    }
  }